import React from 'react'
import { GridColumns } from '@mui/x-data-grid'
import { Box, Chip, Container } from '@mui/material'
import { translate as t } from '../../../i18n'
import { Avatar } from '../../../components/Avatar'
import useResponsive from 'hooks/useResponsive'

export const Columns: GridColumns = [
  {
    field: 'name',
    renderHeader: () => (t('training.gridColumns.label')),
    flex: 2.5,
    valueGetter: (params) => params.row.athlete.name,
    renderCell: (params) => {
      return <Container sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Avatar imagePath={params?.row?.athlete.imagePath} name={params.row?.athlete.name} />
        <Box sx={{ display: 'flex', flexDirection: 'column', paddingLeft: 2, textAlign: 'left' }}>
          <span style={{ fontWeight: 'bold' }}>{params?.row?.athlete.name} {params?.row?.athlete.surname}</span>
          { useResponsive('up', 'md') && <span>{params?.row?.athlete.email}</span> }
        </Box>
      </Container>
    }
  },
  {
    field: 'birthday',
    renderHeader: () => (t('training.gridColumns.birthday')),
    type: 'date',
    valueGetter: (params) => new Date(params.row.athlete.birthday).toLocaleDateString('pt-BR', { timeZone: 'UTC' }),
    flex: 1
  },
  {
    field: 'whatsapp',
    renderHeader: () => (t('training.gridColumns.phone')),
    flex: 1,
    valueGetter: (params) => params.row.athlete.whatsapp
  },
  {
    field: 'genre',
    renderHeader: () => (t('training.gridColumns.genre')),
    valueGetter: (params) => t(`genre.${params.row.athlete.genre}`),
    flex: 1
  },
  {
    field: 'verified',
    renderHeader: () => (t('training.gridColumns.status')),
    align: 'center',
    flex: 1,
    valueGetter: (params) => params.row.accepted,
    renderCell: (params) => {
      if (params.row.accepted === true) {
        return <Chip label={t('athlete.status.accepted')} color="primary" variant="outlined"/>
      }
      if (params.row.accepted === false) {
        return <Chip label={t('athlete.status.refused')} color="error" variant="outlined"/>
      }
      return <Chip label={t('athlete.status.pending')}/>
    }
  }
]
